import { useEffect, useState } from 'react';
import { formatDistanceStrict } from 'date-fns';
import { createPollDateLocale } from './pollDateLocale.tsx';
import { type PollTimeSpanTranslations } from '../Poll.model.ts';

const EXPIRY_REFRESH_DELAY = 60000;

const isExpired = (expirationDate: Date): boolean =>
	expirationDate < new Date();

const getExpiry = (
	expirationDate: Date,
	translations: PollTimeSpanTranslations
): string =>
	formatDistanceStrict(expirationDate, new Date(), {
		addSuffix: false,
		locale: createPollDateLocale(translations),
	});

export function useExpiryCounter(
	expirationDate: Date,
	translations: PollTimeSpanTranslations
): [boolean, string] {
	const [expired, setExpired] = useState<boolean>(isExpired(expirationDate));
	const [expiry, setExpiry] = useState<string>(
		getExpiry(expirationDate, translations)
	);

	useEffect(() => {
		const timer = setInterval(() => {
			const defaultExpiry = '0 minutes';
			if (isExpired(expirationDate)) {
				setExpired(true);
				setExpiry(defaultExpiry);
				clearTimeout(timer);
			} else {
				setExpiry(getExpiry(expirationDate, translations) || defaultExpiry);
			}
		}, EXPIRY_REFRESH_DELAY);

		return () => {
			clearTimeout(timer);
		};
	}, []);

	return [expired, expiry];
}
